<div class="avatar" [ngStyle]="styles" [class]="sizeClass">
  <ng-content>
    <span class="label">{{ label }}</span>
  </ng-content>
</div>
